var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M3.333 5h10A6.667 6.667 0 0 1 20 11.667V35a5 5 0 0 0-5-5H3.333zM36.667 5h-10A6.667 6.667 0 0 0 20 11.667V35a5 5 0 0 1 5-5h11.667zM10 13.333h3.333M10 20h3.333M26.667 13.333H30M26.667 20H30"
  })));
};
export default SvgBook;